import React, { ReactElement } from 'react'
import {
  Box,
  Button,
  Container,
  Flex,
  Icon,
  ResetButton,
} from '@mindfulchefuk/design-system'
import { useChooseRecipesContext } from '@mindfulchefuk/onboarding/context/ChooseRecipesContext/ChooseRecipesContext'
import { OnboardingBasketTotalFooterCopy } from '@mindfulchefuk/onboarding/components/OnboardingChooseRecipes/OnboardingBasketTotalFooter/OnboardingBasketTotalFooterCopy'

export const OnboardingBasketTotalFooter = (): ReactElement => {
  const {
    minimumRecipesForPortion,
    handleConfirmRecipesClick,
    isFetchingOnboardingPreviewData,
    isLoading,
    onboardingOrderPreviewTotals,
    toggleCartDrawer,
    totalNumberOfRecipes,
  } = useChooseRecipesContext()

  const disabled = totalNumberOfRecipes < minimumRecipesForPortion

  return (
    <Box
      position="fixed"
      bottom={0}
      left={0}
      right={0}
      bg="white"
      borderTopWidth={1}
      borderColor="pepper-100"
      z={9}
      data-testid="recipes-basket-banner"
    >
      <Container px={[12, 24, 48]} position="relative" py={16}>
        <Box
          position="absolute"
          right={[12, 24, 48]}
          backgroundColor="white"
          borderColor="pepper-100"
          borderStyle="solid"
          borderWidth={1}
          borderBottomWidth={0}
          borderRadius="10px 10px 0 0"
          width={44}
          height={40}
          top={-40}
          display="flex"
        >
          <ResetButton
            display="block"
            fullWidth
            type="button"
            aria-label="Open cart"
            onClick={toggleCartDrawer}
          >
            <Flex
              height="100%"
              width="100%"
              alignItems="center"
              justifyContent="center"
            >
              <Icon type="chevron-up" strokeWidth="3px" size="26px" />
            </Flex>
          </ResetButton>
        </Box>
        <Flex alignItems="center" justify={['space-between', 'flex-end']}>
          <OnboardingBasketTotalFooterCopy
            totalsData={onboardingOrderPreviewTotals}
          />
          <Box
            borderColor={{ sm: 'aubergine' }}
            borderLeftWidth={{ sm: 1 }}
            pl={{ sm: 40 }}
          >
            <Button
              variant="primary"
              size={['medium', 'large']}
              type="button"
              disabled={
                disabled || isFetchingOnboardingPreviewData || isLoading
              }
              onClick={handleConfirmRecipesClick}
              data-testid="continue-cta"
            >
              Continue
            </Button>
          </Box>
        </Flex>
      </Container>
    </Box>
  )
}
